export const detectEmployeeAutoContributionIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * --------e-------------------------- */
    if (cleaned === "delete auto pf process" || cleaned === "remove auto contribution") {
        return { intent: "delete_auto_pf_process" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) auto pf process/);
    if (deleteMatch) {
        return { intent: "auto_pf_process", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("auto pf process") || cleaned.includes("auto pf process")) {
        return { intent: "auto_pf_process" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/auto pf process named (.+)/);
    if (createMatch) {
        return { intent: "auto_pf_process", name: createMatch[1].trim() };
    }

    return null;
};
